import React from 'react'
import { Box, Chip, Paper, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined'
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined'
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import { PositionGrid } from '../../../interfaces/Position/Position'

interface PositionDetailProps {
  item: PositionGrid
}

interface DetailCardProps {
  icon: React.ReactNode
  label: string
  value?: React.ReactNode
}

const DetailCard: React.FC<DetailCardProps> = ({ icon, label, value }) => (
  <Paper
    variant='outlined'
    sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, borderRadius: 2 }}
  >
    <Box
      sx={{
        width: 48,
        height: 48,
        borderRadius: '50%',
        backgroundColor: 'rgba(63, 81, 181, 0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        color: 'primary.main'
      }}
    >
      {icon}
    </Box>
    <Box>
      <Typography variant='caption' color='text.secondary'>
        {label}
      </Typography>
      <Typography variant='subtitle1' fontWeight={700}>
        {value ?? <Typography component='span' variant='subtitle1' fontStyle='italic' color='text.disabled'>Sin información</Typography>}
      </Typography>
    </Box>
  </Paper>
)

export const PositionDetail: React.FC<PositionDetailProps> = ({ item }) => (
  <Grid container spacing={2}>
    <Grid size={{ xs: 12, md: 6 }}>
      <DetailCard
        icon={<Inventory2OutlinedIcon />}
        label='Nombre Posición'
        value={item.positionName}
      />
    </Grid>
    <Grid size={{ xs: 12, md: 6 }}>
      <DetailCard
        icon={<LocationOnOutlinedIcon />}
        label='Tipo Posición'
        value={item.typePosition?.typePositionDescription}
      />
    </Grid>
    <Grid size={{ xs: 12, md: 6 }}>
      <DetailCard
        icon={<HomeWorkOutlinedIcon />}
        label='Almacén'
        value={item.warehouse?.warehouseName}
      />
    </Grid>
    <Grid size={{ xs: 12, md: 6 }}>
      <DetailCard
        icon={<StoreOutlinedIcon />}
        label='Zona'
        value={item.zone?.zoneName}
      />
    </Grid>
    <Grid size={{ xs: 12, md: 3 }}>
      <DetailCard
        icon={<VerifiedUserOutlinedIcon />}
        label='Estado'
        value={
          <Chip
            label={item.active ? 'Activo' : 'Inactivo'}
            color={item.active ? 'primary' : 'default'}
            size='small'
            sx={{ mt: 0.5 }}
          />
        }
      />
    </Grid>
    <Grid size={{ xs: 12, md: 9 }}>
      <DetailCard
        icon={<DescriptionOutlinedIcon />}
        label='Descripción'
        value={item.positionDescription || undefined}
      />
    </Grid>
  </Grid>
)
